import axios from 'axios'


/* SYC : GA 태그 API 호출
*  Return Type      : Json Object/int
*  Return prameter  : 소프트웨어/windows 상품 ID
*  Description      : 운영체제설치서비스 상품 비교
*/

export const commonAPI = {

  getWindowsItemList: function() {
    const url = `${process.env.REACT_APP_API_URL}/front/v3/items?idx_b_manager=1&cate_id=1030200000&offset=0&limit=90&sort=1&type...,maker,hotdeal,event&maker=&spec=%7B%7D&min=0&max=0&keyword=`
    return axios.get(url);
  },
}

export const itemAPI = {
    baseUrl: process.env.REACT_APP_API_URL,
    getPriceList: function(priceType, itemList) {
        var _url = this.baseUrl + '/front/v1/estimate/compare?priceType=' + priceType + '&itemList=' + itemList
        return axios.get(_url)
    },

    //윈도우OS 상품 호출 API 추가
    getWindowsItemList: async function () {
        const _url = this.baseUrl + `/front/v3/items?idx_b_manager=1&cate_id=1030200000&offset=0&limit=90&sort=1&type...,maker,hotdeal,event&maker=&spec=%7B%7D&min=0&max=0&keyword=`
        return await axios.get(_url)
    },


    getItemCompareList: async function(cate_id, item_id) {
        const _url = this.baseUrl + `/front/v3/pc/compareview?cateId=${cate_id}&itemId=${item_id}`
        const config = {
            withCredentials: true,
            xsrfHeaderName: 'Authorization',
        }
        return await axios.get(_url,config)
    },

    getCurationsImg: function(cateId,adCode){
        const _url = this.baseUrl + `/front/v3/curation/${cateId}/1?ad=${adCode}`
        return axios.get(_url)
    }
}

export const serviceAPI = {
    baseUrl: process.env.REACT_APP_API_URL,
    /**
     * 240610
     * getServicePriceList 사용하는 곳이 없어 주석
     * */
    // getServicePriceList: function(priceType, itemList, idx_b_manager) {
    //     let form = new FormData();
    //     itemList.map((value) => (
    //         form.append('items[]', value)));
    //     form.append('priceType', priceType);
    //     const _url = this.baseUrl + '/front/v3/item/serviceitem'
    //     return axios.post(_url, form)
    // },
    getOsListWithOsInstall: function() {
        const _url = this.baseUrl + '/front/v3/curation/1030000000/1?ad=SVP004&curationOpt=rand&limit=1&ad_num=333'
        return axios.get(_url)
    },
}




// WEBPACK FOOTER //
// ./src/estimate_list/components/api/common.js